export const SUPPORTED_LANGUAGES = ['en', 'zh-TW', 'ko', 'ja'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

/**
 * Detects the most suitable supported locale based on a browser language string.
 */
export function detectLocale(browserLang: string | null): SupportedLanguage {
  if (!browserLang) return 'en';
  const lang = browserLang.toLowerCase();
  
  if (lang.startsWith('zh')) return 'zh-TW';
  if (lang.startsWith('ko')) return 'ko';
  if (lang.startsWith('ja')) return 'ja';
  
  return 'en';
}
